import { useEffect, useState } from 'react';
import { getAuth, createUserWithEmailAndPassword, deleteUser } from 'firebase/auth';
import { toast } from 'react-toastify';
import { addDoc, collection, doc, setDoc } from "firebase/firestore";
import { db } from '../Firebase';
import Loading from './Loading';
import { useUser } from '../Context';
import { useNavigate } from 'react-router-dom';
import groupImage from "../Assets/6104399_3153465.png"
import graph from "../Assets/graph6.png"
import eye from "../Assets/eye.png"
import eyebrow from "../Assets/eyebrow.png"

export default function SignUp() {
    const { user, loading, setLoading } = useUser()
    const [name, setName] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [address, setAddress] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [visiblePassword, setVisiblePassword] = useState(false);
    const navigate = useNavigate()
    useEffect(() => {
        if (user) {
            console.log(user)
            navigate('/');
            // toast.error("Already signed in.");
            return;
        }
    }, [user])

    const handleSignUp = async (e) => {
        e.preventDefault();
        if(!name || !companyName || !phoneNumber || !address || !email || !password){
            toast.warn("Please fill all the details.");
            return;
        }
        try {
            setLoading(true);
            const auth = getAuth();
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            console.log(user)
            if (user) {
                try {
                    const docRef = await setDoc(doc(db, "lessee", user.uid), {
                        name,
                        companyName,
                        phoneNumber,
                        address,
                        email,
                        leaseList: [],
                        adminAuthorization:false
                    });
                    console.log(docRef);
                    toast.success("Account created.")
                } catch (error) {
                    try {
                        await deleteUser(user)
                        toast.error("Error in creating user.");
                        console.log("Error in creating user, auth deleted.");
                        return;
                    } catch (error) {
                        console.log("Error in deleting auth user", error);
                        return;
                    }
                }
            }
        } catch (error) {
            let errorMessage = error.message.split('auth/')[1].split(')')[0].split('-').join(" ");
            console.log(error.message.split('auth'))
            toast.error(errorMessage);
            console.error("Error signing up:", error.message);
        }
        setName("")
        setCompanyName("")
        setAddress("")
        setPhoneNumber("")
        setEmail("")
        setPassword("")
        navigate('/sign-in');
        setLoading(false)
    };

    return (
        <>
        {loading && <Loading />}
        <main className='w-screen px-24 h-[88vh] gap-12 flex items-center justify-between  bg-cover'>
            <form className='flex flex-col gap-4 w-6/12 justify-center  rounded-lg h-full p-2 px-12'>
                <h1 className='text-center w-fit text-[2.8rem] antialiased font-semibold text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text'>Sign Up</h1>
                <div className='border hover:shadow-lg focus-within:shadow-lg focus-within:scale-105  group p-3 py-0 rounded-xl transition-all duration-200 flex w-full gap-3 items-center'>
                    <h2 className=' text-blue-500'>Name:</h2>
                    <input className='outline-none w-full h-full px-2 py-4 ' type='text' placeholder='John Doe' onChange={((e) => setName(e.target.value))} value={name} />
                </div>
                <div className='border hover:shadow-lg focus-within:shadow-lg focus-within:scale-105  group p-3 py-0 rounded-xl transition-all duration-200 flex w-full gap-3 items-center'>
                    <h2 className=' text-blue-500'>Phone:</h2>
                    <input className='outline-none w-full h-full px-2 py-4' type='text' placeholder='1234567890' onChange={((e) => setPhoneNumber(e.target.value))} value={phoneNumber} />
                </div>
                <div className='border hover:shadow-lg focus-within:shadow-lg focus-within:scale-105  group p-3 py-0 rounded-xl transition-all duration-200 flex w-full gap-3 items-center'>
                    <h2 className=' text-blue-500'>Company:</h2>
                    <input className='outline-none w-full h-full px-2 py-4' type='text' placeholder='LMS pvt. ltd.' onChange={((e) => setCompanyName(e.target.value))} value={companyName} />
                </div>
                <div className='border hover:shadow-lg focus-within:shadow-lg focus-within:scale-105  group p-3 py-0 rounded-xl transition-all duration-200 flex w-full gap-3 items-center'>
                    <h2 className=' text-blue-500'>Address:</h2>
                    <input className='outline-none w-full h-full px-2 py-4' type='text' placeholder='A-32, Rocal Street, Pune' onChange={((e) => setAddress(e.target.value))} value={address} />
                </div>
                <div className='border hover:shadow-lg focus-within:shadow-lg focus-within:scale-105  group p-3 py-0 rounded-xl transition-all duration-200 flex w-full gap-3 items-center'>
                    <h2 className=' text-blue-500'>Email:</h2>
                    <input className='outline-none w-full h-full px-2 py-4' type='email' placeholder='johndoe@gmail.com' onChange={((e) => setEmail(e.target.value))} value={email} />
                </div>
                <div className='border hover:shadow-lg focus-within:shadow-lg focus-within:scale-105  group p-3 py-0 rounded-xl transition-all duration-200 flex w-full gap-3 items-center'>
                    <h2 className=' text-blue-500'>Password:</h2>
                    <input className='outline-none w-full h-full px-2 py-4' type={visiblePassword ? "text" : "password"} placeholder='John@Do3' onChange={((e) => setPassword(e.target.value))} value={password} />
                    {!visiblePassword ?
                        <img className='h-6 pr-2 cursor-pointer transition-all' src={eye} onClick={() => { setVisiblePassword(!visiblePassword) }} alt='eye' />
                        :
                        <img className='h-6 pr-2 cursor-pointer transition-all' src={eyebrow} onClick={() => { setVisiblePassword(!visiblePassword) }} alt='eye' />
                    }
                </div>
                <button type='submit' className='bg-gradient-to-tr hover:shadow-lg hover:shadow-gray-300 duration-200 from-sky-500 to-indigo-500 transition-all w-fit  px-4 text-lg rounded-md font-normal py-2 text-white' onClick={(e)=>{handleSignUp(e)}}>Create User</button>
            </form>
            <img className='h-11/12 p-24 bg-cover aspect-square object-contain' alt='hi' src={groupImage} style={{ backgroundImage: `url(${graph})` }} />
        </main>
        </>
    );
}
